module.exports = __webpack_public_path__ + "media/images/meta/cyclebar_aus/apple-touch-icon-76343afda178a04c2be9b72f7a8caade.png";